//请自行添加语言资源
const coalShip = {
  plantName:'基地',
  transportNo:"运输安排计划单",
  shipNo:'运作单',
  carrierName:'承运商',
  vehicleNo:'车牌号',
  driverName: '司机姓名',
  driverTel: '司机电话',
  vehicleInPlantTime: '车辆入场时间',
  vehicleOutPlantTime: '车辆出厂时间',
  shipStatus: '运作单状态',
  destStorageName: '收货库位',
  expectUnloadWeighValue: '预估下站重量',
  unpeelWeight: '重车称重-重量',
  peelWeight: '回皮称重-重量',
  unloadTime: '卸货时间',
  unloadUser: '卸货人',
  msg:{
  }
};
export default coalShip



// WEBPACK FOOTER //
// ./src/page/bd/coal/coalShip/lang/coalShip.zh.js